/**
 * Footer language dropdown.
 *
 * Toggles the pop-up panel listing the other available languages.
 * Ported from the "Visit Lands of Vicenza" implementation.
 */
export function initFooterLanguageSwitcher(root = document) {
  const dropdowns = Array.from(root.querySelectorAll('[data-footer-lang-dropdown]'));
  if (!dropdowns.length) return;

  function closeDropdown(dropdown) {
    const toggle = dropdown.querySelector('[data-footer-lang-dropdown-toggle]');
    if (!toggle || !dropdown.classList.contains('is-open')) return;
    dropdown.classList.remove('is-open');
    toggle.setAttribute('aria-expanded', 'false');
  }

  function openDropdown(dropdown) {
    const toggle = dropdown.querySelector('[data-footer-lang-dropdown-toggle]');
    const panel = dropdown.querySelector('[data-footer-lang-dropdown-panel]');
    if (!toggle || !panel || dropdown.classList.contains('is-open')) return;
    panel.hidden = false;
    dropdown.classList.add('is-open');
    toggle.setAttribute('aria-expanded', 'true');
  }

  dropdowns.forEach((dropdown) => {
    const toggle = dropdown.querySelector('[data-footer-lang-dropdown-toggle]');
    if (!toggle) return;

    toggle.addEventListener('click', (event) => {
      event.preventDefault();
      dropdowns.forEach((item) => {
        if (item !== dropdown) closeDropdown(item);
      });
      if (dropdown.classList.contains('is-open')) {
        closeDropdown(dropdown);
      } else {
        openDropdown(dropdown);
      }
    });
  });

  // Click anywhere outside the switcher to close it.
  document.addEventListener('click', (event) => {
    if (!(event.target instanceof Element)) return;
    if (event.target.closest('[data-footer-lang-dropdown]')) return;
    dropdowns.forEach(closeDropdown);
  });

  // Escape closes it too.
  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    dropdowns.forEach(closeDropdown);
  });
}
